import React from 'react';
import RollingCount from '../Vendor/Jackpot/RollingCount';
import promotionConfig from '../../promotionConfig';

const ProgressiveJackpot = () => {
    const jackpotConfigs = promotionConfig?.jackpots ?? [];

    return (
        <div className='progressive-jackpot-meter'>
            <RollingCount path={promotionConfig.animationPath} jackpots={jackpotConfigs} />
        </div>
    );
};

export default ProgressiveJackpot;
